export function request (obj) {
  return new Promise(function (resolve, reject) {
    const url = obj.url || ''
    const method = obj.method || 'GET'
    const params = obj.params || {}

    const xhr = new XMLHttpRequest();
    xhr.open(method, 'https://wefuture.org.cn/' + url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(params));
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve()
        } else {
          reject()
        }
      }
    }
  })
}